export interface StatusConexaoState {
  conectado: boolean;
}

export const statusConexaoState: StatusConexaoState = {
  conectado: true,
};
